var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg1204(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1250 1250",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M288.047,861.847l641.778,0.236c-0,-0 224.183,-24.636 227.456,-252.949c3.445,-240.236 -240.978,-255.234 -247.568,-267.237c-48.952,-89.166 -82.232,-209.362 -296.896,-210.635c-265.896,-1.576 -303.759,321.291 -314.437,323.865c-80.371,19.37 -206.886,50.573 -205.541,221.287c1.348,171.105 195.208,185.433 195.208,185.433Z",
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M284.898,439.118c-59.29,14.599 -136.956,38.008 -179.48,108.154c-19.405,32.011 -31.766,73.81 -31.329,129.29c1.476,187.229 212.576,203.984 212.576,203.984c0.457,0.034 0.916,0.051 1.375,0.051l641.778,0.236c0.686,0 1.373,-0.037 2.055,-0.112c-0,-0 240.644,-26.343 244.156,-271.319c2.944,-205.254 -162.534,-257.401 -232.846,-276.275c-7.74,-2.077 -15.669,-4.339 -19.921,-5.571c-29.36,-54.621 -55.191,-118.685 -116.382,-162.523c-42.854,-30.701 -102.947,-51.981 -193.952,-52.52c-127.562,-0.757 -206.063,68.236 -254.679,144.93c-46.335,73.095 -64.852,153.09 -73.351,181.675Zm3.858,403.977c-11.841,-0.992 -175.991,-17.433 -177.168,-166.829c-0.37,-46.948 9.477,-82.466 25.898,-109.554c38.865,-64.11 112.976,-80.749 165.287,-93.357c3.273,-0.789 7.413,-2.566 11.044,-7.202c1.368,-1.747 3.387,-5.196 5.212,-10.559c2.056,-6.044 4.823,-16.55 8.673,-30.199c22.394,-79.402 83.743,-276.576 285.003,-275.383c80.727,0.479 134.322,18.272 172.336,45.506c58.117,41.635 80.092,104.138 108.236,155.402c1.477,2.69 4.29,6.344 9.856,9.168c4.526,2.295 15.332,5.232 30.327,9.257c61.362,16.472 207.642,60.394 205.073,239.52c-2.916,203.401 -194.872,232.506 -209.834,234.466c-30.036,-0.01 -639.919,-0.234 -639.919,-0.234l-0.024,-0.002Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M606.366,952.624l-92.811,166.051",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.522,952.624l-92.811,166.051",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M892.008,1035.65l-185.621,-0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M844.714,951.706l-92.811,166.051",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.603,1117.53l-92.81,-166.051",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "33.33px"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1204);
export default __webpack_public_path__ + "static/media/1204.76946706796b599423f16852f16406ec.svg";
export { ForwardRef as ReactComponent };